import { Chip } from "@octopusdeploy/design-system-components";
import { GitIcon } from "@octopusdeploy/design-system-octopus-components";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type React from "react";
import { withTheme } from "~/components/Theme";
export const GitChip: React.FC<{
    enabled: boolean;
}> = ({ enabled }) => {
    return withTheme((theme) => {
        if (enabled) {
            return <Chip icon={<GitIcon style={{ color: themeTokens.color.icon.inverse.primary, width: "18px", height: "18px" }}/>} label="Enabled" backgroundColor={theme.successText} labelColor={themeTokens.color.text.inverse.primary}/>;
        }
    });
};
GitChip.displayName = "GitChip"
